<script setup lang="ts">
export interface UIToolbarProps {
    height?: string
}
const props = withDefaults(defineProps<UIToolbarProps>(), {
    height: '42px'
})
</script>

<template>
    <div
        class="toolbar"
    >
        <div class="toolbar__left">
            <slot name="left" />
        </div>

        <div class="toolbar__center">
            <slot name="center" />
        </div>

        <div class="toolbar__right">
            <slot name="right" />
        </div>
    </div>
</template>

<style scoped lang="scss">
.toolbar {
    display: grid;
    grid-template-areas: 'left center right';
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    justify-content: stretch;
    height: 100%;
    width: 100%;
    padding: 15px 30px;
    min-height: v-bind('props.height');
    gap: 0.5rem;

    &__left {
        justify-self: flex-start;
        align-self: center;
        grid-area: left;
        display: flex;
        align-items: center;
    }

    &__center {
        display: flex;
        align-self: center;
        grid-area: center;
        align-items: center;
        justify-self: center;
        word-break: break-word;
        font-size: $font-size-base;
        font-weight: $toolbar-center-font-weight;
        text-align: center;
        text-transform: $toolbar-center-text-transform;

        @media (min-width: $screen-sm) {
            font-size: $font-size-lg;
        }
    }

    &__right {
        justify-self: flex-end;
        align-self: center;
        grid-area: right;
        display: flex;
        align-items: center;
    }
}
</style>
